import { Modal, Button, ModalHeader } from "reactstrap";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const AddModal = ({
  show,
  setShow,
  modalBody,
  showButton,
  title,
  onSubmitHandler,
  validationError,
  formArray,
  isAddOrEdit,
  duplicateTutor,
  defaultRoles,
  saveBtn,
  disableOutsideClick = false,
  size = "xl",
  hideSubmit = false,
  isDisabled
}) => {
  const [isValid, setIsValid] = useState(validationError);
  const { t, i18n } = useTranslation();
  
  return (
    // {/********************* MODAL *****************/}
    <Modal
      size={size}
      isOpen={show}
      toggle={() => {
        if (!disableOutsideClick) {
          setShow(false);
        }
      }}
    >
      {/********************* MODAL HEADER *****************/}
      <ModalHeader tag="div" className="modalClose">
        <div className="d-flex justify-content-between align-items-center w-100">
          {i18n.language === "ar" ? (
            <>
              <button
                type="button"
                className="btn-close ms-2"
                onClick={() => setShow(false)}
                aria-label="Close"
              ></button>
              <h5 className="modal-title mb-0">{title}</h5>
            </>
          ) : (
            <>
              <h5 className="modal-title mb-0">{title}</h5>
              <button
                type="button"
                className="btn-close ms-2"
                onClick={() => setShow(false)}
                aria-label="Close"
              ></button>
            </>
          )}
        </div>
      </ModalHeader>

      {/* ********************* MODAL BODY ***************** */}
      <form onSubmit={onSubmitHandler} encType="multipart/form-data">
        <div className="modal-body">{modalBody}</div>
        <div className="modal-footer">
          <Link
            to="#"
            className="btn btn-link link-success fw-medium"
            onClick={() => setShow(false)}
          >
            <i className="ri-close-line me-1 align-middle"></i> {t("Close")}
          </Link>
          {isAddOrEdit !== "isAcademic" &&
            isAddOrEdit !== "payments" &&
            isAddOrEdit !== "ViewSessions" &&
            !saveBtn &&
            !hideSubmit && (
              <Button
                type="submit"
                disabled={
                  isAddOrEdit !== "addRoles" && formArray?.length === 0
                    ? true
                    : false || duplicateTutor
                    ? true
                    : false || defaultRoles
                    ? true
                    : false || isDisabled 
                    ? true
                    : false
                }
                color="primary"
              >
                <i className="ri-save-3-fill align-bottom me-2 ms-2"></i>
                {t("Save Changes")}
              </Button>
            )}

          {isAddOrEdit !== "isAcademic" &&
            isAddOrEdit === "payments" &&
            !saveBtn &&
            !hideSubmit && (
              <Button type="submit" color="primary">
                <i className="ri-save-3-fill align-bottom me-2 ms-2"></i>
                {t("Save payment")}
              </Button>
            )}
          {isAddOrEdit !== "isAcademic" &&
            isAddOrEdit !== "payments" &&
            isAddOrEdit !== "ViewSessions" &&
            saveBtn &&
            !hideSubmit && (
              <Button type="submit" disabled={showButton} color="primary">
                <i className="ri-save-3-fill align-bottom me-2 ms-2"></i>
                {t("Save Changes")}
              </Button>
            )}
        </div>
      </form>
    </Modal>
  );
};

AddModal.propTypes = {
  onSubmitHandler: PropTypes.func,
  show: PropTypes.bool,
};

export default AddModal;
